import React from "react"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import WalletAsAService from "@/containers/WalletAsAService/WalletAsService_Index"
import { useRouter } from "next/router"
import { useTranslation } from "next-i18next"

const ComplianceIndex = () => {
  const { t } = useTranslation(["walletAsAService", "common"])
  const { locale } = useRouter()
  return <WalletAsAService t={t} local={locale} />
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "walletAsAService",
      "common",
      "contactUs",
      "homepage"
    ]))
  }
})

export default ComplianceIndex
